export const NO_TAG_REGEX = /^{!tag=.*[^{]+}/;
export const QUOTES_REGEX = /["']/g;
export const NO_TAG_AND_FACET_REGEX = /^[^:]*:/;
